export default {
  welcome: 'Welcome',
  subtitle: 'Please enter your account and password',
  email: 'Account',
  emailPlaceholder: 'Please enter your account',
  password: 'Password',
  passwordPlaceholder: 'Please enter your password',
  or: 'or',
  noAccount: "Don't have an account?",
  contactAdmin: 'Contact Administrator',
  forgotPasswordTip: 'Please contact administrator to reset password',
  contactAdminTip: 'Please contact administrator to get an account',
};
